import { z } from 'zod'

export const AppSchema = z.object({
  id: z.number(),
  version: z.number(),
  title: z.string(),
  description: z.string(),
  status: z.string(),
})
